import styled from 'styled-components'
import { rhythm, media } from '../utils/typography'

export default styled.div`
  width: 100%;
  margin: 0 auto;

  padding: 0 ${rhythm(1/3)};
  ${media.tablet} { padding: 0 ${rhythm(1/2)} }
  ${media.desktop} { padding: 0 ${rhythm(2)} }

  ${media.desktop} { max-width: 1200px }
  ${media.wide} { max-width: 1600px }
`
